import { Injectable } from '@angular/core';
import { HttpParameterCodec } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

export const CARRIERDEVICE = {
    PALLET: { code: 1, name: 'パレット' },
    BASKET_CART : { code: 2, name: 'カゴ車' },
}

export const DEFAULT_FLOOR = 'デフォルト';

// export funaction which returns CARREIRDEVICE object
export function getCarrierDevice(code: number) {
    switch (code) {
        case CARRIERDEVICE.PALLET.code:
            return CARRIERDEVICE.PALLET;
        case CARRIERDEVICE.BASKET_CART.code:
            return CARRIERDEVICE.BASKET_CART;
        default:
            return null;
    }
}

// export function which returns array of CARRIERDEVICE objects
export function getCarrierDeviceList() {
    return [
        CARRIERDEVICE.PALLET,
        CARRIERDEVICE.BASKET_CART
    ];
}

@Injectable()
export class CarrierdeviceService {
    private apiSpringUrl = '/spring/carrierdevices';

    constructor(private http: HttpService) { }

    get(
        ownerId?: number
    ): Promise<any> {
        let url:string = '';
        if (ownerId !== undefined) {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
        } else {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        }
        return this.http.get(url);
    }

    post(
        ownerId: number,
        floorCd: string,
        carrierdevicetypeCd: string,
        carrierdeviceTx: string,
        widthNr: number,
        depthNr: number,
        heightNr: number,
        fillinglimitNr: number,
        updprogramCd: string
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        const jsonInput = {
            ownerId: ownerId,
            floorCd: floorCd,
            carrierdevicetypeCd: carrierdevicetypeCd,
            carrierdeviceTx: carrierdeviceTx,
            widthNr: widthNr,
            depthNr: depthNr,
            heightNr: heightNr,
            fillinglimitNr: fillinglimitNr,
            updprogramCd: updprogramCd
        };
        return this.http.post(url, jsonInput);
    }

    put(
        carrierdeviceId: number,
        ownerId: number,
        floorCd: string,
        carrierdevicetypeCd: string,
        carrierdeviceTx: string,
        widthNr: number,
        depthNr: number,
        heightNr: number,
        fillinglimitNr: number,
        updprogramCd: string,
        updcounterNr: number
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${carrierdeviceId}`;
        const jsonInput = {
            ownerId: ownerId,
            floorCd: floorCd,
            carrierdevicetypeCd: carrierdevicetypeCd,
            carrierdeviceTx: carrierdeviceTx,
            widthNr: widthNr,
            depthNr: depthNr,
            heightNr: heightNr,
            fillinglimitNr: fillinglimitNr,
            updprogramCd: updprogramCd,
            updcounterNr: updcounterNr
        };
        return this.http.put(url, jsonInput);
    }

    delete(
        carrierdeviceId: number
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${carrierdeviceId}`;
        return this.http.delete(url);
    }

}


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/carrierdevice/carrierdevice.service.ts